module.exports = __webpack_public_path__ + "static/media/hero2.b102c088.svg";